export const roundReviewScore = (score, roundTo) => {
  const divisor = roundTo === 'half' ? 2 : 10
  return Math.round(score * divisor) / divisor
}

export const stripHtml = (html) => html?.replace(/(<([^>]+)>)/gi, '')

// @see @chordcommerce/gatsby-theme-autonomy/src/utils/formatters
export const toUsdCurrency = (number, alwaysShowCents = false) => {
  if (number % 1 === 0 && !alwaysShowCents) return fraction.format(number)
  else return formatter.format(number)
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
})

const fraction = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
})
